// extracted by mini-css-extract-plugin
module.exports = {"airDate":"airDate__3Gekz","dark":"dark__13PJM"};